import * as React from "react";
import { DetailFields } from "./DetailFields";

export function DetailsTab() {
  return <DetailFields />;
}
